import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="bg-background-100 py-14 md:py-20" aria-label="订阅引流区">
      <div className="px-4 md:px-6 max-w-4xl mx-auto text-center">
        <div className="relative rounded-2xl overflow-hidden mb-10 md:mb-14">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20photography%20with%20warm%20grainy%20film%20texture%2C%20dramatic%20light%20and%20shadow%20composition%2C%20mysterious%20atmosphere%2C%20vintage%20documentary%20style%2C%20cinematic%20color%20grading%20with%20earthy%20tones%2C%20soft%20focus%20background%2C%20editorial%20quality&width=1200&height=600&seq=cta-bg-2026&orientation=landscape"
            alt="独家爆料资源"
            className="w-full aspect-[2/1] object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 to-transparent"></div>
        </div>

        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug mb-2">
          全网首发<span className="italic font-normal text-foreground-400"> · </span>
          实锤曝光<span className="italic font-normal text-foreground-400"> · </span>
        </h2>
        <h3 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug mb-8">
          独家资源
        </h3>

        <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto mb-10 leading-relaxed">
          不想错过任何一个大瓜？订阅黑料吃瓜爆料中心，第一时间获取全网最热爆料推送，做朋友圈里最懂瓜的人。
        </p>

        <Link
          to="/category/daily-contest"
          className="whitespace-nowrap inline-flex items-center gap-2 px-10 py-3.5 rounded-full bg-foreground-950 text-background-50 font-semibold text-sm md:text-base hover:bg-foreground-800 transition-colors cursor-pointer"
        >
          进入吃瓜热榜
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}